import React, { useEffect, useState } from "react";
import media from "../../../media";
import { Link } from "react-router-dom";
import Select from "react-select";
import CardHeader from "../../../components/atoms/cardHeader";
import { useDispatch, useSelector } from "react-redux";
import { ChangeStatusInStoreThunk } from "../../../store/thunks/orderThunk";

export const StorePickup = ({ data, orderRefId }) => {
  const dispatch = useDispatch();
  const { data: inStore, error: instoreError } = useSelector(
    (state) => state.orderInStore
  );
  const [page, setPage] = useState(false);

  useEffect(() => {
    if (inStore) {
      setPage(false);
    }
  }, [inStore]);
  useEffect(() => {
    if (instoreError) {
      setPage(true);
    }
  }, [instoreError]);

  return (
    <>
      {page ? (
        <div className="align-items-center d-flex font-weight-bolder h-200px justify-content-center">
          No Order Found With Respect To The Shipment
        </div>
      ) : (
        <>
          <div className="card card-custom mb-5">
            <CardHeader name="Store pickup Items" />
            <div className="border-1 border-dark border-top-0 card-body p-0">
              <div className="table-responsive" style={{ overflowX: "unset" }}>
                <table className="table table-bordered text-center m-0 border radius-remove">
                  <thead>
                    <tr>
                      <th className="width text-lef table-width-ten">Items</th>
                      <th className="align-middle table-width-ten">
                        Delivery Option
                      </th>
                      <th className="align-middle table-width-ten">
                        Item Dimesions
                      </th>
                      <th className="align-middle table-width-ten">Status</th>
                      <th className="align-middle table-width-twofive">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.shippingInformation?.productGroup?.map(
                      (dataList, index) => {
                        return (
                          <tr key={index.toString()}>
                            <td className="align-middle" nowrap="nowrap">
                              <div className="text-center text-capitalize">
                                <div className="symbol symbol-60 flex-shrink-0">
                                  <img
                                    src={
                                      dataList?.productImage
                                        ? dataList?.productImage
                                        : media?.user
                                    }
                                    alt=""
                                    className="w-100"
                                  />
                                </div>
                                <div className="font-weight-bolder">
                                  <span className="d-block">
                                    {dataList?.productName?.en}
                                  </span>
                                  <span className="text-muted d-block my-1">
                                    SKU: {dataList?.sku}
                                  </span>
                                  <span className="text-muted d-block">
                                    Quantity : {dataList?.quantity}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="align-middle" nowrap="nowrap">
                              <span className="bg-warning p-1 px-2 text-white rounded font-size-sm">
                                {dataList?.deliveryOption ===
                                "PICK_UP_FROM_VENDOR"
                                  ? "PICK UP"
                                  : "HOME DELIVERY"}
                              </span>
                            </td>
                            <td className="align-middle" nowrap="nowrap">
                              <div className="d-flex flex-column">
                                <div className="mb-1">
                                  <span className="font-weight-bold mr-2">
                                    Length :
                                  </span>
                                  <span className="text-muted">
                                    {dataList?.dimension?.length?.quantity +
                                      " " +
                                      dataList?.dimension?.length?.unit}
                                  </span>
                                </div>
                                <div className="mb-1">
                                  <span className="font-weight-bold mr-2">
                                    Width :
                                  </span>
                                  <span className="text-muted">
                                    {dataList?.dimension?.width?.quantity +
                                      " " +
                                      dataList?.dimension?.width?.unit}
                                  </span>
                                </div>
                                <div className="mb-1">
                                  <span className="font-weight-bold mr-2">
                                    Height :
                                  </span>
                                  <span className="text-muted">
                                    {dataList?.dimension?.height?.quantity +
                                      " " +
                                      dataList?.dimension?.height?.unit}
                                  </span>
                                </div>
                                <div className="">
                                  <span className="font-weight-bold mr-2">
                                    Weight :
                                  </span>
                                  <span className="text-muted">
                                    {dataList?.dimension?.weight?.quantity +
                                      " " +
                                      dataList?.dimension?.weight?.unit}
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td className="align-middle" nowrap="nowrap">
                              <div className="d-flex flex-column">
                                <span className="font-weight-bold">
                                  {dataList?.orderStatus === "DELIVERED"
                                    ? "ITEM COLLECTED"
                                    : dataList?.orderStatus === "PACKED"
                                    ? "PICKUP READY"
                                    : dataList?.orderStatus}
                                </span>
                              </div>
                            </td>

                            {dataList?.orderStatus !== "CANCELLED" ? (
                              <td
                                className="align-middle table-width-twofive"
                                nowrap="nowrap"
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  options={[
                                    { label: "PICKUP READY", value: "PACKED" },
                                    {
                                      label: "ITEM COLLECTED",
                                      value: "DELIVERED",
                                    },
                                    { label: "CANCELLED", value: "CANCELLED" },
                                  ]}
                                  onChange={(val) => {
                                    dispatch(
                                      ChangeStatusInStoreThunk({
                                        orderStatusChangeRequest: {
                                          orderStage: val.value,
                                          orderRefID: orderRefId,
                                        },
                                      })
                                    );
                                  }}
                                ></Select>
                              </td>
                            ) : (
                              <td> This Order is Cancelled</td>
                            )}
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/*Store pickup Items End*/}

          {/*Invoice Start*/}
          <div className="card card-custom">
            <CardHeader name="Invoice" />
            <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-10">
              <div className="text-center my-5">
                <Link
                  className="btn btn-dark font-weight-bold letter-spacing btn-md"
                  to="#"
                >
                  Print invoice
                </Link>
              </div>
            </div>
          </div>
          {/*Invoice End*/}
        </>
      )}
    </>
  );
};
